import './NumberInputQuestion.scss';

export const NumberInputQuestion = ({ question, description, onNumberChange, number }) => {
  return (
    <div className="number-input-question">
      <div className="question">{question}</div>
      <div className="input">
        <input
          type="number"
          value={number}
          onChange={(e) => {
            const value = parseInt(e.target.value);

            ((value >= 0 && value <= 99) || e.target.value === '') && onNumberChange(value || '');
          }}
          min={1}
          max={99}
        />
        <div className="description">{description}</div>
      </div>
    </div>
  );
};
